import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchWithCSRFTokenForRequestObject } from "Utils/fetchWithCSRFToken";

import { appendAuthParams } from "Common/TokenAuth/Utils";

import type { Intuit } from "./types";

export const intuitApi = createApi({
  reducerPath: "intuitApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/",
    fetchFn: fetchWithCSRFTokenForRequestObject,
  }),
  tagTypes: ["IntuitStatus"],
  endpoints: (builder) => ({
    getIntuitStatus: builder.query<Intuit.Status, Intuit.StatusRequest>({
      query: ({ company_id_token = "" } = {}) => ({
        url: appendAuthParams(`/intuit/status`),
        method: "GET",
        params: { company_id_token },
      }),
      providesTags: ["IntuitStatus"],
    }),
  }),
});

export const { useGetIntuitStatusQuery } = intuitApi;
